import PageHeader from "@/components/PageHeader";
import { CONTACT_EMAIL, WHATSAPP_NUMBER } from "@/lib/brand";

const AvisoPrivacidad = () => (
  <div data-testid="aviso-privacidad-page">
    <PageHeader
      eyebrow="Legal"
      title="Aviso de Privacidad."
      subtitle="Última actualización: febrero 2026 · En cumplimiento de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP, México)."
    />

    <section className="px-6 md:px-14 pb-24 max-w-4xl">
      <article
        className="card-soft p-8 md:p-12 space-y-6"
        style={{ background: "#fbf6ec" }}
      >
        <Block title="1. Responsable del tratamiento de datos">
          <p>
            <strong>Psychelibrium, Psicología Clínica y Forense</strong> (en
            adelante, «Psychelibrium») es responsable del uso, protección y
            confidencialidad de sus datos personales. Contacto:{" "}
            <a href={`mailto:${CONTACT_EMAIL}`} style={ink}>{CONTACT_EMAIL}</a> ·
            WhatsApp: +{WHATSAPP_NUMBER.slice(0, 2)} {WHATSAPP_NUMBER.slice(2, 12)}.
          </p>
        </Block>

        <Block title="2. Datos personales que recabamos">
          <ul style={list}>
            <li>Identificación: nombre completo, fecha de nacimiento (cuando aplique).</li>
            <li>Contacto: correo electrónico, teléfono/WhatsApp.</li>
            <li>Datos sensibles (con su consentimiento expreso): motivo de consulta,
                antecedentes psicológicos, historia clínica, información familiar y
                de pareja necesaria para el proceso terapéutico o el peritaje.</li>
          </ul>
        </Block>

        <Block title="3. Finalidades del tratamiento">
          <p>Sus datos serán utilizados exclusivamente para:</p>
          <ul style={list}>
            <li>Brindar atención psicológica clínica y/o forense en línea.</li>
            <li>Agendar, confirmar y dar seguimiento a sesiones.</li>
            <li>Emitir dictámenes, informes técnicos o metaperitajes cuando aplique.</li>
            <li>Cumplir con obligaciones fiscales y legales aplicables.</li>
            <li>Enviar comunicaciones informativas relacionadas con su proceso.</li>
          </ul>
        </Block>

        <Block title="4. Transferencia de datos">
          <p>
            Sus datos <strong>no serán compartidos ni vendidos</strong> a terceros,
            salvo mandato judicial expreso o cuando la ley así lo requiera (por
            ejemplo, presentación de un peritaje ante tribunales).
          </p>
        </Block>

        <Block title="5. Derechos ARCO">
          <p>
            Usted tiene derecho a <strong>Acceder</strong>, <strong>Rectificar</strong>,{" "}
            <strong>Cancelar</strong> u <strong>Oponerse</strong> al tratamiento de sus
            datos personales, así como a revocar el consentimiento otorgado. Para
            ejercer estos derechos, escríbanos a{" "}
            <a href={`mailto:${CONTACT_EMAIL}`} style={ink}>{CONTACT_EMAIL}</a> indicando
            su nombre completo y el derecho que desea ejercer.
          </p>
        </Block>

        <Block title="6. Medidas de seguridad">
          <p>
            Adoptamos medidas administrativas, técnicas y físicas razonables para
            proteger sus datos, incluyendo almacenamiento cifrado, videollamadas
            seguras y acceso restringido únicamente al psicólogo responsable de su
            caso.
          </p>
        </Block>

        <Block title="7. Menores de edad">
          <p>
            La atención a adolescentes se brinda con el consentimiento informado y
            firmado de al menos uno de los padres, madres o tutores legales.
          </p>
        </Block>

        <Block title="8. Cambios al aviso">
          <p>
            Nos reservamos el derecho de actualizar este Aviso. Cualquier cambio
            será publicado en esta misma página; si el cambio es sustancial, se lo
            comunicaremos por correo electrónico.
          </p>
        </Block>
      </article>
    </section>
  </div>
);

const Block = ({ title, children }) => (
  <section>
    <h2
      style={{
        fontFamily: "Cormorant Garamond, serif",
        fontSize: "1.35rem",
        fontWeight: 600,
        color: "var(--p-black)",
      }}
    >
      {title}
    </h2>
    <div
      className="mt-3 space-y-2"
      style={{
        fontFamily: "Cormorant Garamond, serif",
        color: "var(--p-brown)",
        fontSize: "1.05rem",
        lineHeight: 1.7,
      }}
    >
      {children}
    </div>
  </section>
);

const list = { paddingLeft: 20, listStyle: "disc" };
const ink = { color: "var(--p-burgundy)", textDecoration: "underline" };

export default AvisoPrivacidad;
